export interface StoredBrandCriteriaPreference {
  id: string;
  preferences: BrandCriteriaPeference[];
}

export interface BrandCriteriaPeference {
  id: string;
  brand: {
    id: string;
    name: string;
  };
  start: Date;
  end: Date;
  brandOrder: number;
}
